import { Checkbox, Col, DatePicker, Form, Row } from 'antd'
import CustomSpin from '../../../../../../elements/CustomSpin'
import FormSectionTitle from '../../../../../../elements/FormSectionTitle'
import withKeyValue from '../../../../../../elements/HOC/WithKeyValue'
import withSort from '../../../../../../elements/HOC/withSort'
import useFetchSelectUrl from '../../../../../../elements/Hooks/useFetchSelectUrl'
import CustomSelect from '../../../../../../elements/Select/CustomSelect'
import withData from '../../../../../../elements/Select/withData'
import { rules, threeFormItemLayout } from '../../../../../../modules/FormItems'
import moment from 'moment'
import React from 'react'

import { compose } from 'recompose'

const StatusName = compose(
  withData({
    data: ['All', 'Draft', 'Revised', 'Submitted', 'Resubmitted', 'Active', 'Approved', 'Delivered'],
  }),
  withSort,
  withKeyValue()
)(CustomSelect)

const YearSelect = compose(
  withData({
    data: [
      { value: 'All', key: 'All' },
      { value: 'Paid', key: 'Paid' },
      { value: 'Not Paid', key: 'notPaid' },
      { value: 'Invoiced', key: 'Invoiced' },
      { value: 'Registered', key: 'Registered' },
    ],
  })
)(CustomSelect)

function POAndPayPlanForm(props) {
  const { submitting } = props
  const { getFieldDecorator, getFieldValue } = props.form

  const [CompaniesSelect] = useFetchSelectUrl({
    name: `corporates`,
    url: `corporates/`,
    /*payload: [
      {
        _id:
          'members/294426460313,members/294427115673,members/294426198169,members/294426329241,members/294457000089,members/10333923050595,members/3473770102937,members/294426591385,members/4834795471001,members/294426722457,members/294426853529,members/294426984601,members/294427246745,members/294428950681',
        fn: 'Only Mondiale Companies',
      },
    ],*/
  })

  return (
    <CustomSpin spinning={submitting}>
      <Form>
        <FormSectionTitle title={'Details'} />
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Status'}>
              {getFieldDecorator('status', {
                initialValue: 'Active',
                rules: rules.select,
              })(<StatusName />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Start'}>
              {getFieldDecorator('start', {
                initialValue: moment().subtract(12, 'months'),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="Start" />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'End'}>
              {getFieldDecorator('end', {
                initialValue: moment(),
                rules: rules.date,
              })(<DatePicker style={{ width: '100%' }} placeholder="End" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Company">
              {getFieldDecorator('company')(<CompaniesSelect keyAtr={'_id'} valueAtr={'fn'} />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'PayPlan Status'}>
              {getFieldDecorator('payPlanStatus', {
                initialValue: 'notPaid',
              })(<YearSelect />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Stock Orders'}>
              {getFieldDecorator('isIntercompany', {
                valuePropName: 'checked',
                initialValue: false,
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomSpin>
  )
}

POAndPayPlanForm.propTypes = {}
POAndPayPlanForm.defaultProps = {
  selection: [],
}

export default Form.create()(POAndPayPlanForm)
